<template>
  <section class="container container_play">
    <div class="video_play">
      <video controls>
        <source :src="url" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="video_head">
      <div class="video_info">
        <div class="channel_icon">
          <img :src="tagClass[1]" alt="" />
        </div>
        <div class="title">
          <h4 v-text="title"></h4>
          <div class="resource" v-text="subTitle"></div>
        </div>
      </div>
      <div class="heart_tag">
        <div :class="tagClass[0]" v-text="videoTag"></div>
        <div class="heart" @click="toggleLike">
          <img v-if="isLiked" :src="require('@/assets/images/heart_click.svg')" :alt="'like ' + isLiked" />
          <img v-if="!isLiked" :src="require('@/assets/images/heart.svg')" :alt="'like ' + isLiked" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import videoSource from "@/assets/images/farm_video.mov";
import { mapState } from "vuex"; // 引入 mapState
export default {
  //   props: ["videoId"],

  props: {
    // videoId: {
    //   type: String,
    //   required: true,
    // },
    video: {
      required: true,
    },
  },
  data() {
    return {
      //   videoSource: "/videos/farm_video.mov"
      id: "",
      url: "",
      title: "",
      subTitle: "",
      videoTag: "",
      liked: false,
      isLiked: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    tagClass() {
      switch (this.videoTag) {
        case "Music & Rhythm":
          return ["tag_1", require("@/assets/images/music_icon.svg")];
        case "Shapes & Colors":
          return ["tag_2", require("@/assets/images/shape_icon.svg")];
        case "Alphabet & Numbers":
          return ["tag_3", require("@/assets/images/alphabet_icon.svg")];
        case "Animal Names":
          return ["tag_4", require("@/assets/images/animal_icon.svg")];
        case "Science Concepts":
          return ["tag_5", require("@/assets/images/science_icon.svg")];
        // 如果有更多的 videoTag，您可以在此添加更多的 case
        default:
          return ["tag_3", require("@/assets/images/music_icon.svg")]; // 默認的 class，您可以根據需要修改
      }
    },
  },
  mounted() {
    // Get videoList from session storage
    // const videoList = JSON.parse(sessionStorage.getItem("videoList"));

    // console.log("videoList = " + this.videoList);
    // Find the video with the provided videoId
    // const videoData = this.videoList.find((video) => video.id === this.videoId);

    // Map the properties of videoData to the component's data
    this.id = this.video.id;
    this.url = this.video.url;
    this.title = this.video.title;
    this.subTitle = this.video.subTitle;
    this.videoTag = this.video.videoTag;
    this.liked = this.video.liked;
    this.isLiked = this.video.liked;
  },
  methods: {
    toggleLike() {
      this.isLiked = !this.isLiked;
      this.$emit("update-liked", { id: this.id, liked: this.isLiked });
    },
  },
};
</script>

<style>
/* --------------------- play video ---------------------*/
.video_head {
  display: flex;
  justify-content: space-between;
}

.video_info {
  display: flex;
  float: left;
  width: 75%;
}

.video_play {
  height: 78vh;
  /* Set the container to the full viewport height */
  width: 100%;
  overflow: hidden;
  /* Prevent scrollbars */
  background-color: black;
  margin-bottom: 20px;
}

.video_play video {
  width: auto;
  /* Automatically adjust the width */
  height: 100%;
  /* Make sure the video takes up the full height of its container */
  object-fit: contain;
  /* This will make sure the video maintains its aspect ratio */
  display: block;
  /* Remove default margin/padding */
  margin: 0 auto;
  /* Center the video horizontally */
}

.tag_1,
.tag_2,
.tag_3,
.tag_4,
.tag_5 {
  font-size: 12px;
  color: #fff;
  padding: 0 6px;
}

.tag_1 {
  background-color: #6bb2a4;
}

.tag_2 {
  background-color: #de6c6b;
}

.tag_3 {
  background-color: #F0CA30;
}

.tag_4 {
  background-color: #FFAE4A;
}

.tag_5 {
  background-color: #AEDCED;
}

.heart_tag .tag_1 {
  margin-bottom: 10px;
}

.heart_tag .tag_2 {
  margin-bottom: 10px;
}

.heart_tag .tag_3 {
  margin-bottom: 10px;
}

.heart_tag .tag_4 {
  margin-bottom: 10px;
}

.heart_tag .tag_5 {
  margin-bottom: 10px;
}

.heart_tag .heart {
  float: right;
}

.container_play {
  margin-top: 5%;
}

.video_play {
  margin-top: -80px;
}

.material-symbols-outlined {
  display: block;
  margin-bottom: 20px;
}

.back_arrow {
  margin-top: 25px;
}
</style>